import { Badge } from '@/components/ui/badge';
import type { Cashier } from '@/hooks/use-employees';
import { useT } from '@/i18n/use-t';

export function CashierGpStores({ cashier }: { cashier: Cashier }) {
  const t = useT();
  if (!cashier.gpStores?.length) {
    if (cashier.gpStoresSynced === undefined)
      return <span className="text-muted-foreground">—</span>;
    return (
      <span className="text-sm text-muted-foreground">
        {cashier.gpStoresSynced
          ? t('employees.gp_stores.none', 'No GP store assignments')
          : t('employees.gp_stores.pending', 'GP store data not received')}
      </span>
    );
  }
  return (
    <ul className="space-y-1 text-sm">
      {cashier.gpStores.map((store) => (
        <li key={store.code} className="flex flex-wrap items-center gap-2">
          <span>{store.name ?? store.code}</span>
          {store.name && (
            <span className="font-mono text-xs text-muted-foreground">{store.code}</span>
          )}
          {store.id === null ? (
            <Badge variant="outline">
              {t('employees.gp_stores.unresolved', 'Store details not received')}
            </Badge>
          ) : (
            !store.active && (
              <Badge variant="outline">
                {t('employees.gp_stores.inactive', 'Inactive assignment')}
              </Badge>
            )
          )}
        </li>
      ))}
    </ul>
  );
}
